import React from 'react';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/style/market.module.scss';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import SubTitleBar from 'src/webapp/views/component/title/SubTitleBar';//서브타이틀

export default function SearchArea(props) {
    const { marketList, setSearchWord, status, setStatus, isPartner, setIsPartner } = props;//props

    /* =============== 검색어 엔터이벤트 =============== */
    const onEnterHandler = (e) => {
        if(e.key !== "Enter") { return; }
        setSearchWord(e.target.value);
    }
    /* =============== 검색어 엔터이벤트 =============== */
    /* =============== 검색어 입력값없을떄 =============== */
    const onChangeHandler = (e) => {
        const value = e.target.value;
        if(value.length > 0) { return; }
        setSearchWord(value);
    }
    /* =============== 검색어 입력값없을떄 =============== */

    return (
        <>
        <Element tag={`div`} className={styles.searchContainer}>
            <Element tag={`div`} className={styles.searchArea}>
                <FontAwesomeIcon icon="fa-light fa-magnifying-glass" />
                <input type="text" onKeyDown={(e) => onEnterHandler(e)} onChange={(e) => onChangeHandler(e)} />
            </Element>
        </Element>      
        <SubTitleBar title={`상품(${marketList.length > 0 ? marketList[0].TOT_CNT : 0})`}>
            <Element tag={`div`} className={styles.checkedContainer}>
                <Element tag={`div`} className={styles.checkedArea}>
                    <input type="checkbox" className={'checkbox'} onChange={(e) => setStatus(!status)}  />
                    <Element tag={`label`}>거래가능만 보기</Element>
                </Element>
                <Element tag={`div`} className={styles.checkedArea}>
                    <input type="checkbox" className={'checkbox'} onChange={(e) => setIsPartner(!isPartner)}  />
                    <Element tag={`label`}>나의 판매내역</Element>
                </Element>
            </Element>
        </SubTitleBar>  
        </>
    );
}